import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getHsaSettings = {
  name: "getHsaSettings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    enabled: z.boolean(),
    reorderHsaPaymentMethodToTop: z.boolean(),
    sendGalePaymentInfoSubmittedEvents: z.boolean(),
  }),
};
